window.addEventListener('DOMContentLoaded', () => {

    let customerStoriesJson = JSON.parse(document.querySelector('[data-customer-stories-json]').text);
    let modalTriggers = document.querySelectorAll('[data-modal-opener="people-love-dialog"]');
    let modalEle = document.querySelector('#people-love-dialog');
    let modalData = document.querySelector('#people-love-dialog [data-modal-data]');
    let storyCards = document.querySelectorAll('.story--card.load-more-items');
    let loadMoreTrigger = document.querySelector('[data-load-more-story]');
    let patinationTrigger = document.querySelector('[data-next-page-url]');
    let reviewsCardsWrapper = document.querySelector('[data-customer-stories-cards]');
  
    if (loadMoreTrigger) {
      loadMoreTrigger.addEventListener('click', (e) => {
        if (storyCards.length > 0) {
          e.preventDefault();
          storyCards.forEach(card => card.classList.remove('load-more-items'));
          storyCards = document.querySelectorAll('.story--card.load-more-items');
        }
      })
    }
  
    if (modalTriggers.length > 0) initModal(modalTriggers);
  
    if (patinationTrigger) {
      patinationTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        patinationTrigger.disabled = true;
        let URL = e.currentTarget.dataset.nextPageUrl + '&sections=template-customer-stories';
        fetch(URL, { method: 'GET' })
          .then(res => res.json())
          .then(data => {
            const parser = new DOMParser();
            const sectionHTMl = parser.parseFromString(data['template-customer-stories'], 'text/html');
  
            if (sectionHTMl.querySelector('[data-customer-stories-json]').text) {
              let newStoreisJson = JSON.parse(sectionHTMl.querySelector('[data-customer-stories-json]').text);
              customerStoriesJson = { ...customerStoriesJson, ...newStoreisJson }
            }
            console.log(customerStoriesJson);
            renderGrid(sectionHTMl);
  
            patinationTrigger.disabled = false;
          })
  
      })
    }
  
    function createModalHtml(data) {

      let html = `
                  <div class="row mt-5 mt-md-7">
                      <div class="col-md-6">
                        <div class="swiper-wrapper__custom">
                          <div class="custom-swiper-navigation d-flex justify-content-between align-items-center position-absolute z-2 w-100">
                            <button class="swiper-button-prev btn-prev-stories"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button>
                            <button class="swiper-button-next btn-next-stories"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
                          </div>
                              <swiper-container class="swiper swiper-slider"
                                loop="false"
                                grabCursor="true"
                                pagination="false"
                                navigation='{
                                    "nextEl": ".btn-next-stories",
                                    "prevEl": ".btn-prev-stories"
                                }'
                                spaceBetween="0"
                                slidesPerView="1"
                              >
                                      ${data.images ? data.images.map(img => `
                                      <swiper-slide class="swiper-slide">
                                          <div class="review-gallery overflow-hidden mx-auto">
                                              <img
                                                  srcset="
                                                      ${img}&width=400 400w,
                                                      ${img}&width=450 450w,
                                                      ${img}&width=550 550w,
                                                      ${img}&width=600 600w,
                                                      ${img}&width=650 650w,
                                                      ${img}&width=720 720w"
                                                  src="${img}&width=400"
                                                  sizes="(min-width: 1440px) 474px, (min-width: 992px) calc((100vw - 30px) / 2), 100vw"
                                                  alt=""
                                                  title="${data.reviewer_name}"
                                                  class="w-100 h-100 object-fit-cover"
                                                  loading="lazy"
                                                  width="1000"
                                                  height="1000"
                                              >
                                          </div>
                                      </swiper-slide>`).join('') : `<p>No image found</p>`}
                              </swiper-container>
                          </div>
                      </div>
                      <div class="col-md-6">
                          <div class="ps-md-4 pt-4 pt-md-0">
                              <div class="custom-reviews mb-3 mb-md-4 lh-1">
                                  ${Array(data.reviews_stars).fill().map(() => `<i class="text-warning icon-size-18 dr-icon-star-fill"></i>`).join('')}
                                  ${Array(5 - data.reviews_stars).fill().map(() => `<i class="text-warning icon-size-18 dr-icon-star"></i>   `).join('')}
                              </div>
                              <h4 class="mb-3">${data.title}</h4>
                              ${data.body_text
          ?
          `<div class="mb-4 mb-md-7">
                                  <description-toggle class="d-block">
                                    <div class="d-none d-md-block" data-description>
                                      ${data.body_text.length > 300
            ?
            `<span class="short-desc" data-short-desc>
                                          ${data.body_text.substring(0, 300) + '...'}
                                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-more" rel="no-follow" title="Read More" aria-label="Read More">Read More</a>
                                        </span>
                                        <span class="full-desc" data-full-desc style="display: none;">
                                          ${data.body_text}
                                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-less" rel="no-follow" title="Read Less" aria-label="Read Less">Read Less</a>
                                        </span>`
            :
            `<div class="desc">${data.body_text}</div>`}
                                    </div>
                                    <div class="d-md-none" data-description>
                                      ${data.body_text.length > 120
            ?
            `<span class="short-desc" data-short-desc>
                                          ${data.body_text.substring(0, 120) + '...'}
                                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-more" rel="no-follow" title="Read More" aria-label="Read More">Read More</a>
                                        </span>
                                        <span class="full-desc" data-full-desc style="display: none;">
                                          ${data.body_text}
                                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-less" rel="no-follow" title="Read Less" aria-label="Read Less">Read Less</a>
                                        </span>`
            :
            `<div class="desc">${data.body_text}</div>`}
                                    </div>
                                  </<description-toggle>
                                </div>`
          :
          ``}
  
                              ${data.location ? `<span class="mb-4 d-block fs-md">${data.location}</span>` : ``}
                              ${data.btn_link ? `<a href="${data.btn_link}" class="btn btn-primary">${data.btn_text}</a>` : ``}
                          </div>
                      </div>
                  </div>`;
      return html;
    }
  
    function initModal(modalTriggers) {
      modalTriggers.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
  
          let modalDataID = e.currentTarget.dataset.scriptId;
          console.log(modalDataID, customerStoriesJson);
          let data = customerStoriesJson[modalDataID];
          if (data) {
            let modalHTML = createModalHtml(data);
            modalData.innerHTML = modalHTML;
            modalEle.show()
          }
        })
      });
    }
  
    function renderGrid(data) {
      let cards = data.querySelector('[data-customer-stories-cards]');
      if (data.querySelector('[data-load-more]')) {
        document.querySelector('[data-load-more]').dataset.nextPageUrl = data.querySelector('[data-load-more]').dataset.nextPageUrl;
      } else {
        document.querySelector('[data-load-more]').classList.add('d-none');
      }
      if (cards) {
        reviewsCardsWrapper.insertAdjacentHTML('beforeend', cards.innerHTML);
        initModal(document.querySelectorAll('[data-modal-opener="people-love-dialog"]'));
      }
    }
  
  });